<template>
	<div>
		<vs-input placeholder="Zoeken" v-model="search" />

		<div class="text-xs text-right" v-if="this.ordersAmount > 0">
			{{ this.ordersAmount }} bestellingen gevonden
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			search: '',
			loading: false,
			page: 0,
			maxPage: 0,
			ordersAmountLastLoad: 0,
		}
	},
	computed: {
		orders() {
			return this.$store.state.openOrdersStore.openOrders.ordersSearch;
		},
		ordersAmount() {
			return this.$store.state.openOrdersStore.openOrders.ordersSearchAmount;
		}
	},
	watch: {
		'search': {
			handler(search) {
				this.clearFoundOrders();

				if (this.timer) {
					clearTimeout(this.timer);
					this.timer = null;
				}

				if (search === '') {
					return;
				}

				this.loading = true;
				this.timer = setTimeout(() => {
					this.loadMoreOrders();
				}, 800);
			}
		},
		'orders'() {
			this.$parent.checkAllSelected();
		},
		'ordersAmount'() {
			if (this.isSearchState()) {
				if (this.ordersAmount < this.ordersAmountLastLoad) {
					if (this.ordersAmount > 0) {
						this.page = Math.floor(this.orders.length / this.$parent.pageSize);

						if (this.loadMoreAvailable()) {
							this.loadMoreOrders();
						}
					}
				}
			}
		}
	},
	methods: {
		isSearchState() {
			return !(this.search === '');
		},
		isSearchLoading() {
			return this.loading;
		},
		isSearchEmpty() {
			return this.ordersAmount === 0;
		},
		getSearchText() {
			return this.search;
		},
		clearFoundOrders() {
			this.$store.dispatch('openOrdersStore/clearSearch').catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het is niet gelukt opnieuw te zoeken',
					color: 'danger'
				});
			});

			this.page = 0;
			this.maxPage = 0;
			this.$parent.selectedOrderIds = [];
		},
		loadMoreAvailable() {
			return !(this.page < this.maxPage)
		},
		loadMoreOrders() {
			const search = this.search.toLowerCase();
			this.page++;

			this.$store.dispatch('openOrdersStore/loadMoreSearch', {
				pageSize: this.$parent.pageSize,
				page: this.page,
				search
			}).then(res => {
				this.maxPage = Math.ceil((this.ordersAmount / this.$parent.pageSize));
				this.ordersAmountLastLoad = this.ordersAmount;

				setTimeout(() => {
					this.loading = false;
				}, 200);
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Het is niet gelukt om meer bestellingen op te halen',
					color: 'danger'
				});
			});
		}
	}
}
</script>

<style>
.vs-con-input {
	max-height: 40px !important;
}

input.vs-input--input {
	max-height: 40px !important;
}
</style>
